import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { VesselCriteriaFilter, VesselCriteriaResults, VesselCriteriaSummary } from '../components';
import { RegulationAction } from '../features/regulation.feature';
import { useAppDispatch } from '../hooks';

const VesselRoute = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        return () => {
            dispatch(RegulationAction.CancelApiRequests());
        };
    }, [dispatch]);

    return (
        <Stack direction={'row'} gap={10}>
            <Stack direction={'column'} width={'20%'} style={{ alignItems: 'center' }}>
                <VesselCriteriaFilter />
            </Stack>
            <Stack direction={'column'} justifyContent={'flex-start'} style={{ width: '60%' }}>
                <VesselCriteriaResults />
            </Stack>
            <Stack direction={'column'} justifyContent={'flex-start'} style={{ width: '20%' }}>
                <VesselCriteriaSummary />
            </Stack>
        </Stack>
    );
};

export default VesselRoute;
